import { queryCardList, queryConventionalList } from "@/views/zhiji/js/services/service.js";

export default {
    state: {
        clusterCards: [],
        cardTotals: "",
        logDetailData: null,
        showClusterReceive: false,
        conventionalData: {
            tableData: [],
            totals: 0,
            queryConditions: {}
        },
        currentLang: "en" //默认为英文
    },
    mutations: {
        updateCardList(state, cardData) {
            state.cardTotals = cardData.totalCards;
            state.clusterCards.splice(0, state.clusterCards.length, ...cardData.cardsList);
            cardData.length > 0 ? "" : (state.showClusterReceive = true);
        },
        updateLogDetail(state, data) {
            state.logDetailData = data.logDetailData;
        },
        clearCardTotals(state) {
            state.cardTotals = "";
        },
        updateConventionalData(state, dataList) {
            state.conventionalData.tableData = dataList.tableData;
            state.conventionalData.totals = dataList.totals;
        },
        updateConventionalQuery(state, data) {
            state.conventionalData.queryConditions = Object.assign({}, state.conventionalData.queryConditions, data);
        },
        updateCurrentLang(state, data) {
            state.currentLang = data;
        }
    },
    actions: {
        queryCardList(context, param) {
            queryCardList(param)
                .then(function(cardData) {
                    context.commit("updateCardList", cardData);
                })
                .catch(err => {
                    context.dispatch("showModal", {
                        type: "MessageModal",
                        data: {
                            type: "tip",
                            message: err.message
                        }
                    });
                });
        },
        queryConventionalList(context, param) {
            param && context.commit("updateConventionalQuery", param);
            queryConventionalList(context.state.conventionalData.queryConditions).then(function(data) {
                context.commit("updateConventionalData", data);
            });
        }
    }
};
